// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folder-project-breadcrumb-wrapper[data-v-5480aca6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n[data-v-5480aca6] a.disabled:hover {\n  color: #777C7F !important;\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
